module.exports = __webpack_public_path__ + "media/images/ln/horoscope_10-e869f272a71fef03958d7b79ea3bb54d.png";